import './App.css';
import {NavBar} from './components/NavBar';
import {Banner} from './components/Banner';
import { Background } from './components/Background';
import { Skills } from './components/Skills';
import { Languages } from './components/Languages';
/* import { Contact } from './components/Contact'; */
import {Spinner} from './components/Spinner';
import { useState, useEffect} from 'react';


function App() {
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [allLoaded, setAllLoaded] = useState(false); 

  useEffect(() => {
    const images = document.querySelectorAll('img');
    const numImages = images.length;

    let count = 0;
    const handleImageLoaded = () => {
      count++;
      if(count === numImages) {
        setImagesLoaded(numImages);
        setAllLoaded(true);
      }
    }

    images.forEach(img => {
      if(img.complete) {
        handleImageLoaded();
      } else {
        img.addEventListener('load', handleImageLoaded);
      }
    });

    return () => {
      images.forEach(img => {
        img.removeEventListener('load', handleImageLoaded);
      });
    };
  }, []);


  return (
    <div className="App">
        <Spinner setImagesLoaded={allLoaded} /> 
        <NavBar  />
        <Banner  />
        <Background  />
        <Skills  />
        <Languages  />

      {/* <Contact  /> */}
    </div>

)}

export default App;
